const TipoUsuario = Object.freeze({
  Ambev: 1,
  Fornecedor: 2,
  Sistema: 3
});

export default TipoUsuario;
